import React from 'react';

export default class EmojiHeart extends React.PureComponent {
  render() {
    return (<span className='emoji' role='img' aria-label='Beating Heart'>💓</span>);
  }
}
